const buildTelephone = (phone) => ({
  country_code: '+55',
  area_code: phone.local.split(')')[0].replace('(', ''),
  local: phone.local.split(')')[1].trim().replace('-', ''),
  phone_type: phone.phone_type,
  extension: phone.extension,
});

export default buildTelephone;
